import type { Customer, Hypotheses, Position, Road, StudioState } from './types';

// Graphe géographique de démonstration à Gentilly, et non inventaire de voirie officiel.
export const NODES: Position[] = [
  [2.338, 48.814], [2.344, 48.814], [2.350, 48.814],
  [2.338, 48.810], [2.344, 48.810], [2.350, 48.810],
  [2.338, 48.806], [2.344, 48.806], [2.350, 48.806],
];
export const ROADS: Road[] = [
  { id: 'r1', name: 'Avenue Raspail · nord', category: 'Voirie classique', from: 0, to: 1, existing: true },
  { id: 'r2', name: 'Avenue Raspail · est', category: 'Voirie classique', from: 1, to: 2, existing: true },
  { id: 'r3', name: 'Rue du Val-de-Marne', category: 'Voirie classique', from: 3, to: 4 },
  { id: 'r4', name: 'Rue de la Division', category: 'Voirie classique', from: 4, to: 5 },
  { id: 'r5', name: 'Avenue Jean-Jaurès · ouest', category: 'Voirie classique', from: 6, to: 7 },
  { id: 'r6', name: 'Avenue Jean-Jaurès · est', category: 'Voirie classique', from: 7, to: 8 },
  { id: 'r7', name: 'Liaison ouest · nord', category: 'Voirie classique', from: 0, to: 3 },
  { id: 'r8', name: 'Liaison ouest · sud', category: 'Voirie classique', from: 3, to: 6 },
  { id: 'r9', name: 'Franchissement central', category: 'Pont', from: 1, to: 4 },
  { id: 'r10', name: 'Rue centrale · sud', category: 'Voirie classique', from: 4, to: 7 },
  { id: 'r11', name: 'Franchissement est', category: 'Autoroute', from: 2, to: 5 },
  { id: 'r12', name: 'Liaison est · sud', category: 'Voirie classique', from: 5, to: 8 },
];
export const CATEGORIES = ['Voirie classique', 'Pont', 'Autoroute'];
export const CUSTOMERS: Customer[] = [
  { id: 'c1', name: 'École Henri-Barbusse', node: 3, demand: 420 },
  { id: 'c2', name: 'Résidence des Acacias', node: 4, demand: 850 },
  { id: 'c3', name: 'Centre sportif municipal', node: 5, demand: 620 },
  { id: 'c4', name: 'Groupe scolaire Jean-Jaurès', node: 6, demand: 510 },
  { id: 'c5', name: 'Résidence Victor-Hugo', node: 7, demand: 1100 },
  { id: 'c6', name: 'Médiathèque de Gentilly', node: 8, demand: 280 },
];
export const roadCoordinates = (road: Road): Position[] => [NODES[road.from], NODES[road.to]];
export const emptyHypotheses = (): Hypotheses => ({
  categories: Object.fromEntries(CATEGORIES.map(c => [c, { mode: 'weighted', weight: 1 }])),
  local: {}, departures: [],
});
export function initialState(): StudioState {
  const hypotheses = emptyHypotheses();
  hypotheses.departures = [{
    id: 'd1', label: 'Départ Raspail', roadId: 'r1', kind: 'network',
    coordinates: roadCoordinates(ROADS[0]),
  }];
  return {
    project: {
      name: 'Gentilly · développement du réseau', perimeter: 'Gentilly',
      extent: '2.336,48.804,2.352,48.816', station: 'Paris-Montsouris',
      dju: 2200, heatRatio: 1, coldRatio: 1, networkKind: 'existing', revision: 1,
    },
    scenarios: [{ id: 's1', name: 'Scénario de référence', hypotheses }],
    plans: [{
      id: 'p1', scenarioId: 's1', name: 'Extension sud · 2026–2028', energy: 'heat',
      subscribers: { c1: '2026-10', c2: '2027-03', c5: '2028-01' },
      pipes: [], stale: false,
    }],
  };
}
export const energyLabel = (energy: 'heat' | 'cold') => energy === 'heat' ? 'Chaleur' : 'Froid';
export const uid = () => crypto.randomUUID();
